import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileMenu", "menuIcon", "closeIcon", "submenu"]

  toggleMobile() {
    const isHidden = this.mobileMenuTarget.classList.contains("hidden")

    if (isHidden) {
      this.mobileMenuTarget.classList.remove("hidden")
      if (this.hasMenuIconTarget) this.menuIconTarget.classList.add("hidden")
      if (this.hasCloseIconTarget) this.closeIconTarget.classList.remove("hidden")
    } else {
      this.mobileMenuTarget.classList.add("hidden")
      if (this.hasMenuIconTarget) this.menuIconTarget.classList.remove("hidden")
      if (this.hasCloseIconTarget) this.closeIconTarget.classList.add("hidden")
    }
  }

  toggleSubmenu(event) {
    const button = event.currentTarget
    const submenu = button.nextElementSibling
    if (!submenu) return

    const isHidden = submenu.classList.contains("hidden")
    submenu.classList.toggle("hidden", !isHidden)

    const chevron = button.querySelector("[data-chevron]")
    if (chevron) {
      chevron.classList.toggle("rotate-180", isHidden)
    }
  }
}
